module.exports = __webpack_public_path__ + "img/logo-ncczj.92de7949.jpg";